module.exports = __webpack_public_path__ + "img/partner_kn.e3b83e6f.jpg";